<template>
  <v-flex xs12 md12 class="mt-0 mb-0 pb-0 mx-0 mx-0">
    <h1 class="py-md-6 px-3 pb-0 mb-0">{{ $t('common.analytics') }}</h1>
    <div class="mx-3 mt-0">
      <v-tabs class="rounded light-shadow">
        <v-tab v-for="tab in tabs" :to="{ path: tab.path }" append :key="tab.title">
          {{ $t(tab.title) }}
        </v-tab>
      </v-tabs>
    </div>
    <router-view class="mx-3 mt-6"></router-view>
  </v-flex>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  props: {},
  name: 'Analytics',
  data: () => ({
    tabIndex: 0,
    tabs: [
      {
        title: 'viewAnalytics.summary.title',
        path: '/analytics/'
      },
      {
        title: 'viewAnalytics.workers.title',
        path: '/analytics/workers/'
      },
      {
        title: 'viewSettings.posts.title',
        path: '/analytics/posts/'
      },
      {
        title: 'viewAnalytics.orders.title',
        path: '/analytics/orders/'
      },
      {
        title: 'viewAnalytics.finances.title',
        path: '/analytics/finances/'
      },
      {
        title: 'viewAnalytics.targets.title',
        path: '/analytics/targets/'
      }
    ]
  }),
  mounted() {

  },
  computed: {},
  methods: {}
}
</script>

<style>

</style>
